import React, { FC } from 'react';
import { HeaderModel } from '../../../models/CommonModel';
import SortableColumn from '../../../components/Table/SortableColumn';
import { formatPrice } from '../../../selectors';
import { ExpenseRowModel } from '../../../models/account-books/ExpensesAccount';
import moment from 'moment';

type Props = {
    data: Array<ExpenseRowModel>,
    header: HeaderModel[]
    hideCols: string[],
    openColConfig: () => void,
    handleSort: (sortBy: string, direction: 'asc' | 'desc' | 'none') => void
};

const ExpensesAccountTable: FC<Props> = ({ data, header, hideCols, openColConfig, handleSort }) => {
    const renderMethod = (method: string) => {
        switch (method) {
            case 'cash':
                return 'Tiền mặt';
            case 'bank':
                return 'Chuyển khoản';
        }
    }

    const renderGroup = (method: string) => {
        switch (method) {
            case 'payroll':
                return 'Chi phí nhân công';
            case 'electric':
                return 'Chi phí điện';
            case 'water':
                return 'Chi phí nước';
            case 'telecom':
                return 'Chi phí viễn thông';
            case 'rent':
                return 'Chi phí thuê kho bãi, mặt bằng KD';
            case 'manage':
                return 'Chi phí quản lý (chi phí VPP, công cụ, dụng cụ, lệ phí môn bài ..)';
            case 'other':
                return 'Chi phí khác (hội nghị, công tác phí, thanh lý, nhượng bán TSCĐ, thuê ngoài khác,...)';
        }
    }

    return (
        <div className='table-responsive'>
            <table className="table table-hover table-bordered table-striped border gy-7 gs-7">
                <thead>
                    <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                        <th>
                            <i 
                                className="fa fa-cogs"
                                style={{cursor: 'pointer'}}
                                onClick={openColConfig}
                            ></i>
                        </th>
                        {header.map((th, index) => {
                            if (!hideCols.includes(th.field)) {
                                if (th.sortable) {
                                    return (
                                        <SortableColumn
                                            key={'th-' + index}
                                            sortBy={th?.field}
                                            onSortChange={handleSort}
                                            style={th?.style ?? {}}
                                        >
                                            {th.label}
                                        </SortableColumn>
                                    )
                                }
                                return (
                                    <th style={th?.style ?? {}}>{th.label}</th>
                                )
                            }
                        })}
                    </tr>
                </thead>
                <tbody>
                    {data?.map((item: ExpenseRowModel, index: number) => {
                        return (
                            <tr key={`agent_${index}`} className="cursor-pointer">
                                <td></td>
                                {!hideCols.includes('posting_date') && (
                                <td>
                                    {moment(item.posting_date).format('DD-MM-YYYY')}
                                </td>
                                )}
                                {!hideCols.includes('doc_no') && (
                                <td>{item?.doc_no ?? ''}</td>
                                )}
                                {!hideCols.includes('expense_group') && (
                                <td>{renderGroup(item.expense_group)}</td>
                                )}
                                {!hideCols.includes('method') && (
                                <td >{renderMethod(item.method)}</td>
                                )}
                                {!hideCols.includes('amount') && (
                                <td style={{textAlign: "right"}}>{formatPrice(item.amount)}</td>
                                )}
                                {!hideCols.includes('description') && (
                                <td >{item.description}</td>
                                )}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default ExpensesAccountTable;